import FocusTrap from './focus-trap';

class KlaroWidget {
    constructor() {
        this.klaro = document.querySelector('#klaro');
        this.learnMore = document.querySelectorAll('.cn-learn-more');
        this.changeConsent = document.querySelectorAll('.change-consent');
        this.focusTrap = null;
    }

    moveKlaro() {
        const main = document.querySelector('.main');
        main.insertBefore(this.klaro, main.firstChild);
    }

    init() {
        this.learnMore.forEach((link) => {
            link.addEventListener('click', this.onLearnMoreClick.bind(this));
        });
        this.changeConsent.forEach((btn) => {
            btn.addEventListener('click', this.onChangeConsentClick.bind(this));
        });
    }

    onLearnMoreClick() {
        this.lastClicked = this.learnMore;
        this.onModalToggle();
    }

    onChangeConsentClick() {
        this.lastClicked = this.changeConsent;
        this.onModalToggle();
    }

    onModalToggle() {
        const cookieModal = document.querySelector('.cookie-modal');
        const isOpen = cookieModal !== null;
        if (isOpen) {
            this.focusTrap = new FocusTrap(cookieModal);
            this.focusTrap.activate();
            this.focusTrap.firstFocusableElement.focus();
            document
                .querySelectorAll('.cm-bg, .cm-header .hide, .cm-btn')
                .forEach((elem) => {
                    elem.addEventListener(
                        'click',
                        this.onModalClose.bind(this)
                    );
                });
        }
    }

    onModalClose() {
        this.learnMore = document.querySelectorAll('.cn-learn-more');
        if (this.learnMore.length > 0) {
            this.learnMore[0].focus();
            this.init();
        } else if (this.lastClicked === this.learnMore) {
            // Focus on the first focusable element in the main content
            const focusableElements = document.querySelectorAll(
                'header main a[href], main button, main input, main select, main textarea, main [tabindex]:not([tabindex="-1"])'
            );
            const visibleFocusableElements = Array.from(
                focusableElements
            ).filter((elem) => elem.offsetParent !== null);
            if (visibleFocusableElements.length > 0) {
                visibleFocusableElements[0].focus();
            }
        } else {
            this.changeConsent[0].focus();
        }
    }
}

export default KlaroWidget;